var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomVideoFile = function SvgCustomVideoFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7V2h-2c-2.828 0-4.243 0-5.121.879C4 3.757 4 5.172 4 8v8c0 2.828 0 4.243.879 5.121C5.757 22 7.172 22 10 22h4c2.828 0 4.243 0 5.121-.879C20 20.243 20 18.828 20 16v-6h-5.054c-.425 0-.837 0-1.176-.046-.384-.051-.821-.177-1.184-.54-.363-.363-.489-.8-.54-1.183C12 7.89 12 7.478 12 7.054V7Zm2 0V2.005c.412.01.684.042.937.147.368.152.657.442 1.235 1.02l2.656 2.656c.579.578.867.868 1.02 1.235.105.253.137.525.147.937H15c-.5 0-.774-.002-.964-.028h-.007l-.001-.008C14.002 7.774 14 7.5 14 7Zm-3.162 5.124 3.496 1.718c.888.436.888 1.88 0 2.316l-3.496 1.718c-.87.428-1.838-.304-1.838-1.39v-2.973c0-1.085.968-1.817 1.838-1.39Z",
    fill: "currentColor"
  })));
};

export default SvgCustomVideoFile;